(function(){
	'use strict';
	angular.module('app.supplyChain')
		.controller('supplierQuality', supplierQuality);
	supplierQuality.$inject = ['$scope', '$rootScope', '$timeout', '$location', '$state', 'leanFilterService', 'tableRenderService', 'tableService', 'storeService', 'redirectParamsService'];

	function supplierQuality($scope, $rootScope, $timeout, $location, $state, leanFilterService, tableRenderService, tableService, storeService, redirectParamsService) {

		var vm = this;
		var unsubscribe;
		$scope.filterService = leanFilterService;
		var reportSettingsName = 'supplier-quality';
		// Extra query params to send to backend in data requests
		var extraParams = [{'excelReportName': 'SupplierQualityReport'}];
		var rendererParams = {};
		// Extra drilldown query params to parse
		var extraFilters = [{
			'name': 'currentDate',
			'type': 'range',
			'comparator': 'Between',
			'valueOne': 'startDate',
			'valueTwo': 'endDate'
		}];
		var pinnedColumns = [];
		var isSupplierPortal = (globalConfig.user.role === 'Supplier');
		var defaultFilters = isSupplierPortal ? [{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }] : [{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }, { 'id': 'supplierNdx', 'values': [$scope.filterService.leanDnaAllSelected] }];

		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		
		vm.showExcel = true;
		vm.broadcastExcel = broadcastExcel;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Supplier Quality';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		init();

		var columns = [
			{ 'id': 'supplierName', 'display': 'Supplier', 'sort': false, 'width': 150},
			{ 'id': 'itemCode', 'display': 'Item Code', 'renderer': tableRenderService.itemCode, 'width': 200},
			{ 'id': 'defects', 'display': 'Number of Defects', 'renderer': tableRenderService.integer, 'width': 100},
			{ 'id': 'total', 'display': 'Total', 'renderer': tableRenderService.integer, 'width': 100},
			{ 'id': 'currentDate', 'display': 'Date', 'renderer': tableRenderService.dateRenderer, 'convertTimeZone': true, 'width': 100}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportSettingsId: reportSettingsId,
			reportUrl: '{0}/SupplierQualityReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'currentDate',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			hideSearch: true,
			setColumnDefaults: true,
			extraFilters: extraFilters,
			excelRequest: true,
			excelReportName: 'SupplierQualityReport'
		};
 
		function init() {
			$scope.filterService = leanFilterService;
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.removable = false;
			
			if (isSupplierPortal) {
				$scope.filterService.setMasterFilterList([siteFilter]);
			} else {
				$scope.filterService.setMasterFilterList([
					siteFilter,
					$scope.filterService.filterDefinitions['Supplier']
				]);
			}
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions['CurrentDate']
			]);
			$scope.filterService.setMasterSingleSelectFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);

			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}
	}

})();
